module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].modal_title))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.sms) ? _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "meta__row"
  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].user) + ":")]), _vm._v(" " + _vm._s(_vm.activeUser && _vm.activeUser.name ? _vm.activeUser.name : '—'))]), _vm._v(" "), _c('div', {
    staticClass: "meta__row"
  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].sent) + ":")]), _vm._v(" " + _vm._s(_vm.humanTime))]), _vm._v(" "), _c('div', {
    staticClass: "meta__row"
  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n[_vm.locale].phone) + ":")]), _vm._v(" " + _vm._s(_vm.sms.phone || '—'))])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))]), _vm._v(" "), _c('div', {
    staticClass: "message__box"
  }, [_vm._v(_vm._s(_vm.sms.message))])])]) : _c('div', {
    staticClass: "d-modal__content"
  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_previous))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].close))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b7a05ab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/SendMessagesPastSmses.vue
// module id = 2102
// module chunks = 1